const accountPayable = require('./clientActivity-report-account-payable')
const accountReceivable = require('./clientActivity-report-account-receivable')
const settings = require('../../../../../js-handler/settings')

export function start(detail) {  //console.log('goku-dt 5>', detail)
      obj[detail.reportType].start(detail)

}/**/

const obj = {
      accountPayable: { start: (detail) => { accountPayable.start(detail) } },
      accountReceivable: { start: (detail) => { accountReceivable.start(detail) } },
      printOrder: { start: (detail) => { printOrder(detail) } },
      setTypeReport: { start: (detail) => { setTypeReport(detail) } },
}

function setTypeReport(detail) {
      const param = settings.getData();
      const reportType = param.entity == 'clientCustomer' ? "accountPayable" : "accountReceivable";

      detail.reportType = reportType;

      start(detail);
}

function printOrder(detail) {
      if (detail.dbid === "" || null) { return }

      const formData = new FormData();
      formData.append('id', detail.dbid);
      formData.append('type', 'print');
      formData.append('entity', detail.entity);
      formData.append('reportName', detail.report);

      const isPdf = true;

      const controller = new AbortController();
      const timeout = setTimeout(() => { controller.abort() }, 30000);

      let options = {
            method: 'POST',
            body: formData,
            signal: controller.signal,
            credentials: 'same-origin'
      };

      fetch(`./server/php/report/report-pdf.php`, options)
            .then((response) => {
                  clearTimeout(timeout);
                  if (!response.ok) throw new Error("report-pdf");
                  // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

                  return response.blob();
            })
            .then((blob) => {
                  if (isPdf) {
                        // --- LÓGICA PARA PDF ---
                        const pdfBlob = new Blob([blob], { type: "application/pdf" });
                        const fileUrl = URL.createObjectURL(pdfBlob);
                        const newTab = window.open(fileUrl, "_blank");

                        if (newTab) {
                              newTab.addEventListener('load', () => {
                                    URL.revokeObjectURL(fileUrl);
                              }, { once: true });
                        }
                  } else {
                        // --- LÓGICA PARA CSV ---
                        // Se define el MIME type para CSV
                        const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
                        const fileUrl = URL.createObjectURL(csvBlob);

                        // Creamos un enlace temporal en el DOM
                        const tempLink = document.createElement("a");
                        tempLink.href = fileUrl;

                        // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
                        tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
                        tempLink.style.display = "none";

                        document.body.appendChild(tempLink);
                        tempLink.click(); // Disparamos la descarga

                        // Limpiamos el DOM y liberamos la memoria
                        document.body.removeChild(tempLink);
                        URL.revokeObjectURL(fileUrl);
                  }
            })

            .catch(error => {
                  throw error;
            });
}
//Account Receivable 